<template>
  <div class="mainList">
    <el-dialog :visible.sync="fundDialogVisible" title="资金费用" @close="close" width="70%">
      <el-select v-model="collection" placeholder="请选择用户组别" clearable>
        <el-option label="已收取" :value="true"></el-option>
        <el-option label="未收取" :value="false"></el-option>
      </el-select>
      <el-date-picker v-model="value1" type="daterange" align="right" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
        unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime($event)"
        :picker-options="pickerOptions">
      </el-date-picker>

      <el-button size="mini" @click="handleSearch" type="primary">搜索</el-button>
      <el-table :data="fundList" style="width: 100%" class="myTable" max-height="400px">
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="symbol" label="合约名" />
        <el-table-column prop="symbolGroupId" label="所属分组ID" />

        <el-table-column label="资金费率">
          <template slot-scope="scope">
            <span>{{
              BigNumber(scope.row.fundingRate * 100).toNumber() | fixD(6)
              }}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="takeAmount" label="总收取" />
        <el-table-column prop="payAmount" label="总发放" />

        <el-table-column label="是否收取">
          <template slot-scope="scope">
            <span class="green" v-if="scope.row.collection">已收取</span>
            <span class="red" v-if="!scope.row.collection">未收取</span>
          </template>
        </el-table-column>

        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime | moment }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span class="green" @click="openfundDetail(scope.row)">资金明细</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :size="paginations.size" :page="paginations.page" :total="fundTotal" @pageChanged="handlePageChanged">
      </pagination>

      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
      </span>
    </el-dialog>
    <FundDetailDialog :fundDetailRow="fundDetailRow" :topChannelUserId="topChannelUserId" :startTime="startTime"
      :endTime="endTime" :fundDetailTimeRange="fundDetailTimeRange"
      :fundDetailDialogVisible="fundDetailDialogVisible" @closefundDetail="closefundDetail" />
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import FundDetailDialog from '../FundDetailDialog'
import BigNumber from 'bignumber.js'
import { mapState, mapActions, mapMutations } from 'vuex'

import moment from 'moment'

export default {
  props: ['fundDialogVisible', 'topChannelUserId', 'fundRow', 'closeFundDialog'],
  data() {
    return {
      topUserId: '',
      paginations: {
        page: 1,
        size: 10,
      },

      startTime: '',
      endTime: '',
      collection: true,
      value1: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      fundDetailRow: null,
      fundDetailTimeRange: [],
      fundDetailDialogVisible: false,
      symbol: '',
    }
  },
  components: { Pagination, FundDetailDialog },
  watch: {
    fundDialogVisible: {
      handler(val, oldVal) {
        if (val) {
          this.getSymbolList()

          this.value1 = [this.fundRow.date, this.fundRow.date]
          this.changeTime(this.value1)
          this.fetchFund({
            ...this.paginations,
            collection: true,
            startTime: this.startTime,
            endTime: this.endTime,
            symbol: '',
            topUserId: this.topChannelUserId,
          })
        }
      },
      deep: true,
      immediate: true,
    },
    topChannelUserId: {
      handler(val) {
        this.topUserId = val
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('transactionStatistics', [
      'fundList',
      'fundTotal',
      'symbolList',
    ]),
  },
  mounted() {
    this.topUserId = this.topChannelUserId
  },
  methods: {
    ...mapActions('transactionStatistics', ['fetchFund', 'getSymbolList']),
    changeTime(e) {
      if (e) {
        // 日期选择器只传日期文本，查询边界固定北京时间，不依赖浏览器时区。
        this.startTime = moment.parseZone(`${e[0]}T00:00:00+08:00`).valueOf()
        this.endTime = moment.parseZone(`${e[1]}T00:00:00+08:00`).endOf('day').valueOf()
      } else {
        this.startTime = ''
        this.endTime = ''
      }
    },
    handlePageChanged(pagination) {
      this.paginations = pagination
      this.getList()
    },
    getList() {
      this.fetchFund({
        ...this.paginations,
        collection: this.collection,
        startTime: this.startTime,
        endTime: this.endTime,
        symbol: '',
        topUserId: this.topChannelUserId,
      })
    },
    handleSearch() {
      this.getList()
    },

    close() {
      this.$emit('closeFundDialog')
    },
    getFundDetailTimeRange(row) {
      const recordTime = row && (row.createdTime || row.date)
      const hour = moment(recordTime)

      if (!hour.isValid()) {
        return [this.startTime, this.endTime]
      }

      return [
        hour.clone().startOf('hour').valueOf(),
        hour.clone().endOf('hour').millisecond(0).valueOf(),
      ]
    },
    openfundDetail(row) {
      this.fundDetailRow = row
      this.fundDetailTimeRange = this.getFundDetailTimeRange(row)
      this.$emit('closeFundDialog')
      this.fundDetailDialogVisible = true
    },
    closefundDetail() {
      this.fundDetailDialogVisible = false
    },
  },
}
</script>

<style lang="less" scoped>
.el-table__header {
  width: 100% !important;

  th.el-table__cell.is-leaf {
    background: #ccc;
  }
}

.el-table__body {
  width: 100% !important;
}

.userBalance {
  color: #409eff;
  cursor: pointer;
}

.userIdInput {
  width: 300px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}

/deep/.el-date-editor {
  margin: 0 20px;
}
</style>
